import queryString from 'query-string';

export function getCheckoutUrl(uploads, generations) {
  let productId = 4104200781865;
  if(generations >= 10) {
    productId = 4909221937193;
  } else if(generations >= 8) {
    productId = 4104200847401;
  } else if(generations >= 6) {
    productId = 4104200814633;
  }

  const product = {
    id: productId,
    quantity: 1,
    properties: {
      low_resolution_preview: uploads['low'],
      image_id: `zWQtTo${uploads['high'].substr(35)}I6XapI`,
      svg_id: `b8pM3o${uploads['svg'].substr(35)}N3xadm`,
      json_id: `lop4ng${uploads['json'].substr(35)}PoQb1a`,
    }
  }
  const page = 'https://familytreeprints.com/pages/chart-preview';
  const url = `${page}?p=${encodeURIComponent(JSON.stringify(product))}`;

  return url;
}

export function getRootsGiftsCheckoutUrl(previewId) {
  const product = queryString.parse(window.location.search);
  const base = "https://rootsgifts.com/a/add/ftp";
  return `${base}/${product.productId}/${previewId}`;
}


// WEBPACK FOOTER //
// ./src/core/shopify/index.js